<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"> </p>
<p class="p4"><i>You can rot here without feeling it.</i></p>
<p class="p4">—John Rechy, on Los Angeles</p>
<p class="p3"> </p>
<p class="p5"> </p>
<p class="p4"><i>I live here in Kill City where the debris meets the sea</i></p>
<p class="p4"><i>It’s a playground for the rich but it’s a loaded gun to me … </i></p>
<p class="p4">—Iggy Pop, on Los Angeles</p>
<p class="p3"><b></b> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section5.vue?1dc7fa53